import * as React from 'react'
import { tryCatch } from '../../utils/tryCatch'
import { ActionBoxPlayback } from './playback'
import { MultiplePlaybackData } from '../../selectors/component/actionBoxComponentSelectors'

interface IMultiplePlaybackProps extends MultiplePlaybackData {}

export const MultiplePlayback = tryCatch(({ playbackDataList, sessionId, pageTitleId, isRetail, playerConfigData, usePlayer }: IMultiplePlaybackProps) => {
  if (!playbackDataList.length) {
    return null
  }

  return <React.Fragment>
    {playbackDataList.map((data, idx) => {
      const props = {
        playbackData: data,
        playerConfigData,
        sessionId,
        pageTitleId,
        isRetail,
        usePlayer,
        isStartOver: idx === 1 // Start Over button is always second one for live events
      }
      return <ActionBoxPlayback key={idx} {...props} />
    })}
  </React.Fragment>
})
